import { useEffect } from 'react'

import { navigate, routes, useLocation } from '@redwoodjs/router'

import { UseSetBackUrlOptions, useSetBackUrl } from '../useSetBackUrl'

import { useCurrentUser } from './useCurrentUser'

export type EnsureAuthenticated = () => Promise<boolean>

type UseEnsureAuthenticatedProps = {
  action?: {
    name: string
    isDone: boolean
    callback: () => Promise<unknown>
  }
  user?: { firstName?: string; lastName?: string; email?: string }
}

export function useEnsureAuthenticated({
  action,
  user,
}: UseEnsureAuthenticatedProps = {}): EnsureAuthenticated {
  const { pathname } = useLocation()
  const setBackUrl = useSetBackUrl()
  const { isAuthenticated } = useCurrentUser()
  const backUrlParams: UseSetBackUrlOptions = { search: {} }
  if (action) {
    backUrlParams.search[action.name] = true
  }

  useEffect(() => {
    if (!action) return
    // could not use useParams because the value
    // doesn't get updated after a replaceState
    const hasActionParam = location.search.includes(`${action.name}=true`)
    if (hasActionParam && isAuthenticated && !action.isDone) {
      history.replaceState(null, '', pathname)
      action.callback()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  return async () => {
    if (!isAuthenticated) {
      setBackUrl(backUrlParams)
      navigate(routes.signin(user))
      return false
    }
    if (action && !action.isDone) {
      await action.callback()
    }
    return true
  }
}
